import { FC } from 'react';
import './styles.scss';

const Logo: FC<{ onClick?: any }> = ({ onClick }) => (

  <a href='https://www.sprinter-rentals.com/' target='_blank'>
    <div className='logo'>
      <img src={`${window.location.origin}/images/logo1.png`} alt='LOGO' />
      {/* <div className='logo__text'>
        SPRINTER <b>RENTALS</b>
      </div> */}
    </div>
  </a>

);
export default Logo;
